import { DatePipe } from '@angular/common';
import { HostListener, ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { MdbTableDirective, MdbTablePaginationComponent } from 'angular-bootstrap-md';
import { AlertService } from 'ngx-alerts';
import { AticuloModule } from '../../modelo/aticulo/aticulo.module';
import { HojaModule } from '../../modelo/hoja/hoja.module';
import { LocalesModule } from '../../modelo/locales/locales.module';
import { MetaModule } from '../../modelo/meta/meta.module';
import { ExcelService } from '../../servicios/excel.service';
import { LoginService } from '../../servicios/login.service';
import { ProducionService } from '../../servicios/producion.service';
import { ReporteService } from '../../servicios/reporte.service';

@Component({
  selector: 'app-meta-local',
  templateUrl: './meta-local.component.html',
  styleUrls: ['./meta-local.component.css']
})
export class MetaLocalComponent implements OnInit {

  listaLocales: LocalesModule[];
  listaProductos: AticuloModule[];
  importHoja: HojaModule[] = [];
  listaProducion: HojaModule[];
  listaMeta: MetaModule[];
  id_pais: string;
  hoja: HojaModule;
  searchText: string = '';
  fechas: string;
  idLocal: string;
  anioMeta: string;
  anioComprar: number;
  metaDevolucion: number;
  metaVenta: number;
  totalVenta1: number;
  totalVenta2: number;
  totalVentaMeta1: number;
  totalDevolucionMeta1: number;
  totalDevolucion1: number;
  totalDevolucion2: number;
  title = 'app';
  userId = 999;
  habilitar:boolean;

  @ViewChild(MdbTablePaginationComponent) mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective) mdbTable: MdbTableDirective;


  previous: any = [];
  constructor(private excelSrv: ExcelService,
    private alertService: AlertService,
    private apiReporte: ReporteService,
    private api: LoginService, private apiHoja: ProducionService, private datepipe: DatePipe) { }

  ngOnInit(): void {
    this.id_pais = localStorage.getItem("id_pais");
    this.listaProducion = [];
    this.listaMeta = [];
    this.listarLocales();
    // this.anioComprar='2020';
    // this.anioMeta='2021';
    this.anioComprar = (new Date().getFullYear() - 1);
    this.anioMeta = (new Date().getFullYear()).toString();
    this.idLocal=localStorage.getItem("local");
    if (localStorage.getItem("rol")=='MaxiPan' || localStorage.getItem("rol")=='Gerencia CF' )
    {     this.habilitar=false;
       
    }else{
     this.habilitar=true;
    }
  }





  @HostListener('input') oninput() {
    this.searchItems();
  }

  searchItems() {
    const prev = this.mdbTable.getDataSource();

    if (!this.searchText) {
      this.mdbTable.setDataSource(this.previous);
      this.listaProducion = this.mdbTable.getDataSource();
    }

    if (this.searchText) {
      this.listaProducion = this.mdbTable.searchLocalDataBy(this.searchText);
      this.mdbTable.setDataSource(prev);
    }
  }

  grabar() {



    this.apiReporte.guardar(this.listaMeta).subscribe((
      data) => {
      this.alertService.info("Se grabo con exito...")
    },
      err => this.alertService.danger('Error no hay  conexion..')
    );


  }

  onChangeLocal($event: Event) {
    //this.buscarProducciones();
  }



  agregar() {

    this.listaProducion = [];
    this.apiHoja.listarProductos(this.idLocal)
      .subscribe((
        data: AticuloModule[]) => {
        this.listaProductos = data;
        console.log(this.listaLocales);
        this.listaProductos.forEach(item => {
          let hoja = new HojaModule();
          hoja.codigo = item.codigo;
          hoja.id_producion = 0;
          hoja.id_local = Number.parseInt(this.idLocal);
          console.log(hoja.fechafinal);
          hoja.producto = item.Nombre;
          this.listaProducion.push(hoja);

        });

      },
        err => this.alertService.danger('Error no hay  conexion..')
      );
    this.mdbTable.setDataSource(this.listaProducion);
    this.mdbTable.dataSourceChange();
    this.previous = this.mdbTable.getDataSource();


  }

  obtenerArticulos() {


    this.apiHoja.listarProductos(this.idLocal)
      .subscribe((
        data: AticuloModule[]) => {
        this.listaProductos = data;
        console.log(this.listaLocales);
      },
        err => this.alertService.danger('Error no hay  conexion..')
      );

  }



  onKeypressEvent(valor: number) {

    this.listaMeta.forEach(element => {

      element.valor_venta = Number.parseFloat(element.venta.toString()) + ((Number.parseFloat(element.meta_venta.toString()) / 100) *
        Number.parseFloat(element.venta.toString()));




    });

    this.totalVenta1 = 0;
    this.totalVenta2 = 0;
    this.totalDevolucion1=0;
    this.totalDevolucion2=0;
    this.totalDevolucionMeta1=0;
    this.totalVentaMeta1=0;
    this.listaMeta.forEach(element => {
     
        this.totalVenta1 = this.totalVenta1 + Number.parseFloat(this.validarNumeros(element.venta_anterior));
     
        this.totalVenta2 = this.totalVenta2 + Number.parseFloat(this.validarNumeros(element.venta));
    
        this.totalDevolucion1 = this.totalDevolucion1 + Number.parseFloat(this.validarNumeros(element.devolucion_anterior));
     
        this.totalDevolucion2 = this.totalDevolucion2 + Number.parseFloat(this.validarNumeros(element.devolucion));
        this.totalDevolucionMeta1=this.totalDevolucionMeta1+Number.parseFloat(this.validarNumeros(element.valor_devolucion));
        this.totalVentaMeta1=this.totalVentaMeta1+Number.parseFloat(this.validarNumeros(element.valor_venta));
    });

  }


  onKeypressEventVent(event: any) {

    this.listaMeta.forEach(element => {
      element.valor_venta = Math.round((Number.parseFloat(event.target.value) / 100) *
        Number.parseFloat(element.venta.toString())) + Number.parseFloat(element.venta.toString());
      element.meta_venta = Math.round(Number.parseFloat(event.target.value));

    });


    this.totalVenta1 = 0;
    this.totalVenta2 = 0;
    this.totalDevolucion1=0;
    this.totalDevolucion2=0;
    this.totalDevolucionMeta1=0;
    this.totalVentaMeta1=0;
    this.listaMeta.forEach(element => {
     
        this.totalVenta1 = this.totalVenta1 + Number.parseFloat(this.validarNumeros(element.venta_anterior));
     
        this.totalVenta2 = this.totalVenta2 + Number.parseFloat(this.validarNumeros(element.venta));
    
        this.totalDevolucion1 = this.totalDevolucion1 + Number.parseFloat(this.validarNumeros(element.devolucion_anterior));
     
        this.totalDevolucion2 = this.totalDevolucion2 + Number.parseFloat(this.validarNumeros(element.devolucion));
        this.totalDevolucionMeta1=this.totalDevolucionMeta1+Number.parseFloat(this.validarNumeros(element.valor_devolucion));
        this.totalVentaMeta1=this.totalVentaMeta1+Number.parseFloat(this.validarNumeros(element.valor_venta));
    });


  }



  onKeypressEventDevCeldad(valor: number) {
    this.listaMeta.forEach(element => {

      element.valor_devolucion = Math.round(Number.parseFloat(element.devolucion.toString()) - ((Number.parseFloat(element.meta_devolucion.toString()) / 100) *
        Number.parseFloat(element.devolucion.toString())));




    });


    this.totalVenta1 = 0;
    this.totalVenta2 = 0;
    this.totalDevolucion1=0;
    this.totalDevolucion2=0;
    this.totalDevolucionMeta1=0;
    this.totalVentaMeta1=0;
    this.listaMeta.forEach(element => {
     
        this.totalVenta1 = this.totalVenta1 + Number.parseFloat(this.validarNumeros(element.venta_anterior));
     
        this.totalVenta2 = this.totalVenta2 + Number.parseFloat(this.validarNumeros(element.venta));
    
        this.totalDevolucion1 = this.totalDevolucion1 + Number.parseFloat(this.validarNumeros(element.devolucion_anterior));
     
        this.totalDevolucion2 = this.totalDevolucion2 + Number.parseFloat(this.validarNumeros(element.devolucion));
        this.totalDevolucionMeta1=this.totalDevolucionMeta1+Number.parseFloat(this.validarNumeros(element.valor_devolucion));
        this.totalVentaMeta1=this.totalVentaMeta1+Number.parseFloat(this.validarNumeros(element.valor_venta));
    });
  }



  onKeypressEventVentCeldad(valor: number) {
    this.listaMeta.forEach(element => {

      element.valor_venta = Math.round(Number.parseFloat(element.venta.toString()) + ((Number.parseFloat(element.meta_venta.toString()) / 100) *
        Number.parseFloat(element.venta.toString())));




    });
    this.totalVenta1 = 0;
    this.totalVenta2 = 0;
    this.totalDevolucion1=0;
    this.totalDevolucion2=0;
    this.totalDevolucionMeta1=0;
    this.totalVentaMeta1=0;
    this.listaMeta.forEach(element => {
     
        this.totalVenta1 = this.totalVenta1 + Number.parseFloat(this.validarNumeros(element.venta_anterior));
     
        this.totalVenta2 = this.totalVenta2 + Number.parseFloat(this.validarNumeros(element.venta));
    
        this.totalDevolucion1 = this.totalDevolucion1 + Number.parseFloat(this.validarNumeros(element.devolucion_anterior));
     
        this.totalDevolucion2 = this.totalDevolucion2 + Number.parseFloat(this.validarNumeros(element.devolucion));
        this.totalDevolucionMeta1=this.totalDevolucionMeta1+Number.parseFloat(this.validarNumeros(element.valor_devolucion));
        this.totalVentaMeta1=this.totalVentaMeta1+Number.parseFloat(this.validarNumeros(element.valor_venta));
    });

  }


  onKeypressEventDev(event: any) {
    this.listaMeta.forEach(element => {
      element.meta_devolucion = Math.round(Number.parseFloat(event.target.value));
      element.valor_devolucion = Math.round(Number.parseFloat(element.devolucion.toString()) - ((Number.parseFloat(event.target.value) / 100) *
        Number.parseFloat(element.devolucion.toString())));




    });
    this.totalVenta1 = 0;
    this.totalVenta2 = 0;
    this.totalDevolucion1=0;
    this.totalDevolucion2=0;
    this.totalDevolucionMeta1=0;
    this.totalVentaMeta1=0;
    this.listaMeta.forEach(element => {
     
        this.totalVenta1 = this.totalVenta1 + Number.parseFloat(this.validarNumeros(element.venta_anterior));
     
        this.totalVenta2 = this.totalVenta2 + Number.parseFloat(this.validarNumeros(element.venta));
    
        this.totalDevolucion1 = this.totalDevolucion1 + Number.parseFloat(this.validarNumeros(element.devolucion_anterior));
     
        this.totalDevolucion2 = this.totalDevolucion2 + Number.parseFloat(this.validarNumeros(element.devolucion));
        this.totalDevolucionMeta1=this.totalDevolucionMeta1+Number.parseFloat(this.validarNumeros(element.valor_devolucion));
        this.totalVentaMeta1=this.totalVentaMeta1+Number.parseFloat(this.validarNumeros(element.valor_venta));
    });


    // console.log(event.target.value);

  }
  listarLocales() {


    this.api.locales(this.id_pais)
      .subscribe((
        data: LocalesModule[]) => {
        this.listaLocales = data;
        console.log(this.listaLocales);

      },
        err => this.alertService.danger('Error no hay  conexion..')
      );

  }

  buscar() {
    this.listarProductos();
  }

  listarProductos() {


    let cliente = '';
    this.listaLocales.forEach(element => {
      if (element.id.toString() == this.idLocal) {
        cliente = element.Nombre_ClientesFinales;
      }

    });


    this.apiReporte.obtenerMeta(cliente.substr(0, 4), this.anioComprar.toString(), this.anioMeta, this.id_pais)
      .subscribe((
        data: MetaModule[]) => {
        this.listaMeta = data;
        console.log(this.listaMeta);
        this.listaLocales.forEach(element => {
          if (element.id.toString() == this.idLocal) {
            cliente = element.Nombre_ClientesFinales;
          }
        });
        this.listaMeta.forEach(element => {
          //element.tipo_cliente=this.idLocal;
          element.cliente = cliente;
          element.fecha = this.anioMeta + "-01-01";

        });
        
        
        this.listaMeta.forEach(element => {
         element.valor_devolucion = Math.round(Number.parseFloat(this.validarNumeros(element.devolucion)) - ((Number.parseFloat(this.validarNumeros(element.meta_devolucion)) / 100) *
            Number.parseFloat(this.validarNumeros(element.devolucion))));
            element.valor_venta = Math.round(Number.parseFloat(this.validarNumeros(element.venta)) + ((Number.parseFloat(this.validarNumeros(element.meta_venta)) / 100) *
            Number.parseFloat(this.validarNumeros(element.venta))));
         

        });
        this.listaMeta.forEach(element => {
          element.id_pais = Number.parseInt(this.id_pais);
        });
        this.totalVenta1 = 0;
        this.totalVenta2 = 0;
        this.totalDevolucion1=0;
        this.totalDevolucion2=0;
        this.totalDevolucionMeta1=0;
        this.totalVentaMeta1=0;
        this.listaMeta.forEach(element => {
         
            this.totalVenta1 = this.totalVenta1 + Number.parseFloat(this.validarNumeros(element.venta_anterior));
         
            this.totalVenta2 = this.totalVenta2 + Number.parseFloat(this.validarNumeros(element.venta));
        
            this.totalDevolucion1 = this.totalDevolucion1 + Number.parseFloat(this.validarNumeros(element.devolucion_anterior));
         
            this.totalDevolucion2 = this.totalDevolucion2 + Number.parseFloat(this.validarNumeros(element.devolucion));
            this.totalDevolucionMeta1=this.totalDevolucionMeta1+Number.parseFloat(this.validarNumeros(element.valor_devolucion));
            this.totalVentaMeta1=this.totalVentaMeta1+Number.parseFloat(this.validarNumeros(element.valor_venta));
        });
      },
        err => this.alertService.danger('Error no hay  conexion..')
      );

  }
  validarNumeros(numero){
    if (!numero){
      return 0;
    }else{
      return numero;
    }
  }

  onAm1(valor: number) {
    // this.periodo();
  }

  periodo() {
    this.listaProducion.forEach(item => {
      this.hoja = new HojaModule();
      this.hoja = item;
      this.hoja.periodo = this.hoja.am1 + this.hoja.am2 + this.hoja.am3 + this.hoja.am4 + this.hoja.am5 + this.hoja.am6 + this.hoja.am7
        + this.hoja.pm1 + this.hoja.pm2 + this.hoja.pm3 + this.hoja.pm4 +
        this.hoja.pm5 + this.hoja.pm6 + this.hoja.pm7;
      item.periodo = this.hoja.periodo;

    });
  }


  onFileChange(evt: any) {
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');

    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      this.listaProducion = [];
      const bstr: string = e.target.result;
      const data = <any[]>this.excelSrv.importFromFile(bstr);

      for (let i = 4; i < data.length; i++) {
        let row = data[i];
        console.log(row);
        this.hoja = new HojaModule();
        if (row.length == 39) {
          for (let j = 0; j < row.length; j++) {
            if (j == 0) {
              this.hoja.codigo = row[j];
            }
            if (j == 1) {
              this.hoja.producto = row[j];
            }
            if (j == 2) {
              if (typeof row[j] === "undefined") {
                this.hoja.fm = 0;
              } else {
                this.hoja.fm = row[j];
              }
            }
            if (j == 3) {
              if (typeof row[j] === "undefined") {
                this.hoja.am1 = 0;
              } else {
                this.hoja.am1 = row[j];
              }
            }
            if (j == 5) {
              if (typeof row[j] === "undefined") {
                this.hoja.pm1 = 0;
              } else {
                this.hoja.pm1 = row[j];
              }
            }
            if (j == 8) {
              if (typeof row[j] === "undefined") {
                this.hoja.am2 = 0;
              } else {
                this.hoja.am2 = row[j];
              }
            }
            if (j == 10) {
              if (typeof row[j] === "undefined") {
                this.hoja.pm2 = 0;
              } else {
                this.hoja.pm2 = row[j];
              }
            }
            if (j == 13) {
              if (typeof row[j] === "undefined") {
                this.hoja.am3 = 0;
              } else {
                this.hoja.am3 = row[j];
              }
            }
            if (j == 15) {
              if (typeof row[j] === "undefined") {
                this.hoja.pm3 = 0;
              } else {
                this.hoja.pm3 = row[j];
              }
            }
            if (j == 18) {
              if (typeof row[j] === "undefined") {
                this.hoja.am4 = 0;
              } else {
                this.hoja.am4 = row[j];
              }
            }
            if (j == 20) {
              if (typeof row[j] === "undefined") {
                this.hoja.pm4 = 0;
              } else {
                this.hoja.pm4 = row[j];
              }
            }
            if (j == 23) {
              if (typeof row[j] === "undefined") {
                this.hoja.am5 = 0;
              } else {
                this.hoja.am5 = row[j];
              }
            }
            if (j == 25) {
              if (typeof row[j] === "undefined") {
                this.hoja.pm5 = 0;
              } else {
                this.hoja.pm5 = row[j];
              }
            }
            if (j == 28) {
              if (typeof row[j] === "undefined") {
                this.hoja.am6 = 0;
              } else {
                this.hoja.am6 = row[j];
              }
            }
            if (j == 30) {
              if (typeof row[j] === "undefined") {
                this.hoja.pm6 = 0;
              } else {
                this.hoja.pm6 = row[j];
              }
            }
            if (j == 33) {
              if (typeof row[j] === "undefined") {
                this.hoja.am7 = 0;
              } else {
                this.hoja.am7 = row[j];
              }
            }
            if (j == 35) {
              if (typeof row[j] === "undefined") {
                this.hoja.pm7 = 0;
              } else {
                this.hoja.pm7 = row[j];
              }
            }
            if (j == 38) {
              if (typeof row[j] === "undefined") {
                this.hoja.periodo = 0;
              } else {
                this.hoja.periodo = row[j];
              }
            }

          }

          this.listaProducion.push(this.hoja);


        }
        this.mdbTable.setDataSource(this.listaProducion);
        this.mdbTable.dataSourceChange();
        this.previous = this.mdbTable.getDataSource();
      }
      console.log(this.listaProducion);

      const header: string[] = Object.getOwnPropertyNames(new HojaModule());
      const importedData = data.slice(1, -1);

      this.importHoja = importedData.map(arr => {
        const obj = {};
        for (let i = 3; i < header.length; i++) {
          const k = header[i];
          obj[k] = arr[i];
          //console.log(arr[i]);
        }
        return <HojaModule>obj;
      })

    };
    // console.log(this.importHoja);
    reader.readAsBinaryString(target.files[0]);

  }

  buscarProducciones() {

    this.apiHoja.listarProduccionPorLocal(this.idLocal, this.id_pais)
      .subscribe((
        data: HojaModule[]) => {
        console.log(data)
        this.listaProducion = data;

        this.mdbTable.setDataSource(this.listaProducion);
        this.mdbTable.stickyHeader
        this.mdbTable.dataSourceChange();
        this.previous = this.mdbTable.getDataSource();
      },
        err => this.alertService.danger('Error no hay  conexion..')
      );


  }
}
